import classNames from "classnames";
import { twMerge } from "tailwind-merge";

const Spinner = () => (
  <span className="inline-block w-4 h-4 mr-2 align-middle">
    <span className="block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
  </span>
);

const Button = ({ className, children, type, onClick, isDisabled, isLoading }) => {
  return (
    <button
      disabled={isDisabled || isLoading}
      onClick={onClick}
      type={type ? type : "button"}
      className={classNames(
        twMerge(
          "text-sm font-semibold bg-primary text-white p-2 rounded-md ease-in duration-100 hover:bg-primary/70 outline-none flex items-center justify-center gap-2",
          className
        ),
        (isDisabled || isLoading) && "cursor-not-allowed bg-primary/30 hover:bg-none"
      )}
    >
      {isLoading && <Spinner />}
      {children}
    </button>
  );
};

export default Button;
